module.exports = __webpack_public_path__ + "static/flags/GQ-3515b81f0e87435e755fff844b97c572.gif";